/**
 * Events Page
 * Business events listing
 */

import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { Calendar, MapPin } from 'lucide-react';

const EventsPage = () => {
  // TODO: Fetch events from API
  const events = [];

  return (
    <>
      <Header />
      
      <main style={{ marginTop: '80px', minHeight: '80vh' }}>
        <section className="section">
          <div className="container">
            <div className="masthead">
              <span className="eyebrow">What's on</span>
              <h1>Events</h1>
              <p>Join us at our upcoming events</p>
            </div>

            {events.length === 0 ? (
              <p style={{ textAlign: 'center', color: '#666' }}>
                No upcoming events at the moment. Check back soon!
              </p>
            ) : (
              <div className="grid grid-2">
                {events.map(event => (
                  <div key={event.id} className="card">
                    {event.coverImage && (
                      <img 
                        src={event.coverImage} 
                        alt={event.name} 
                        className="card-image"
                      />
                    )}
                    <div className="card-content">
                      <h3 className="card-title">{event.name}</h3>
                      <div style={styles.meta}>
                        <span style={styles.metaItem}>
                          <Calendar size={16} /> {new Date(event.date).toLocaleDateString()}
                        </span>
                        {event.location && (
                          <span style={styles.metaItem}>
                            <MapPin size={16} /> {event.location}
                          </span>
                        )}
                      </div>
                      <p className="card-description">{event.description}</p>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
        </section>
      </main>

      <Footer />
    </>
  );
};

const styles = {
  meta: {
    display: 'flex',
    gap: '20px',
    marginBottom: '15px',
    color: '#666',
    fontSize: '0.9rem',
  },
  metaItem: {
    display: 'flex',
    alignItems: 'center',
    gap: '5px',
  },
};

export default EventsPage;
